import swal from 'sweetalert';

/** Success toast */
export function swalSuccess(title, text) {
  if (text != null && String(text).trim() !== '') {
    return swal(String(title), String(text), 'success');
  }
  return swal({ title: String(title), icon: 'success' });
}

/** Warning toast */
export function swalWarning(title, text) {
  const t = title != null && String(title).trim() !== '' ? String(title) : 'Notice';
  const msg = text != null ? String(text) : '';
  if (msg.trim() !== '') return swal(t, msg, 'warning');
  return swal({ title: t, icon: 'warning' });
}

/** Error toast */
export function swalError(title, text) {
  const t = title != null && String(title).trim() !== '' ? String(title) : 'Error';
  const msg = text != null ? String(text) : '';
  if (msg.trim() !== '') return swal(t, msg, 'error');
  return swal({ title: t, icon: 'error' });
}

/** Confirm destructive action; resolves true if user confirms */
export function swalConfirmDelete({ title, text }) {
  return swal({
    title: title ?? 'Are you sure?',
    text: text ?? 'This action cannot be undone.',
    icon: 'warning',
    dangerMode: true,
  }).then((ok) => Boolean(ok));
}
